import EmberService, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';
import { getTs } from 'webapp/utils/common';

// Reverse trial (Experiment 1020231)
// https://app.asana.com/0/527984279702626/1205568780026010/f

// Starting a trial on Growth and Professional plans (Experiment 1220231)
// https://app.asana.com/0/527984279702626/1206092506020404/f

// Cleanup Experiment (Use Growth Monthly for new trials)
// https://app.asana.com/0/527984279702626/1206112884528161/f

// Remove requesting trial right after signup
// (we leave it like it is, implemented some changes on website)
// https://app.asana.com/0/1138028810573038/1207368606274426/f

export default class FlowReverseTrialService extends EmberService {
	@service('billing') declare billingService: Service.Billing;
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('popup') declare popupService: Service.Popup;
	@service('user-settings') declare userSettingsService: Service.UserSettings;

	@tracked isTrialStarted = false;

	autoRequestTrial(): void {
		if (this.currentUserService.model!.created < getTs('2023-10-09 13:00:00')) {
			return;
		}

		if (
			this.currentUserService.loggedInAsPowerUser ||
			!this.currentUserService.isEligibleForAccountOwnerOnboarding
		) {
			return;
		}

		if (
			!this.isTrialStarted &&
			!this.billingService.isTrial &&
			!this.billingService.isPayingCustomer
		) {
			// trial on growth monthly plan
			const plan = this.billingService.availablePlans
				.filter((item) => item.isGrowth)
				.find((item) => item.isMonthly);

			void this.billingService.requestTrial(null, plan, 'onboarding', true);
			this.isTrialStarted = true;
		}
	}
}

declare module '@ember/service' {
	interface Registry {
		'flow/reverse-trial': FlowReverseTrialService;
	}
}
